import * as React from 'react';
import { TileLayer } from 'react-leaflet';
import { useDisplayPreferences } from '../../displayPreferences-context';
import { getTileLayerUrl, TILE_STYLE_REVISION } from './get-tile-layer-url';
/** 1×1 transparent PNG — stops Leaflet retry storms when a tileset 404/400s */
const EMPTY_TILE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==';
export function BuildingDataLayer({ tileset, revisionId }) {
    const { editableBuildings } = useDisplayPreferences();
    if (editableBuildings == "enabled") {
        return React.createElement(TileLayer, { key: `${tileset}-${revisionId}-${TILE_STYLE_REVISION}`, url: getTileLayerUrl(tileset, { rev: revisionId }), errorTileUrl: EMPTY_TILE, minZoom: 9, maxZoom: 19, opacity: 0.92, detectRetina: false });
    }
    else {
        return React.createElement("div", null);
    }
}
